import SectionHeading from '../SectionHeading'
import Div from '../Div';
import ImgTag from '../ImgTag';
import Section from '../Section';

const OurFeatures = ({data , ClassSec , IdSec="" , ClassBox , ClassHead=""}) => {
  return(
      <Section className={ClassSec} id={IdSec}>
        <Div className="container">
          <SectionHeading title='OUR FEATURES' text=' Why Choose Us' />
          <Div className="row">
            {data && data.map((item , key) => (
              <Div className="col-12 col-md-6 col-lg-4" key={key}>
                <Div className={ClassBox} data-wow-delay="0.2s">
                  <Div className="service_icon">
                    <ImgTag src={item.img} alt="" />
                  </Div>
                  <h6 className={ClassHead}>{item.title}</h6>
                  <p>Lorem ipsum dolor sit amet, adipiscing elit. Nulla neque quam, maxi ut ac cu msan ut, posuere sit Lorem ipsum qu.</p>
                </Div>
              </Div>
            ))}
          </Div>
        </Div>
      </Section>
  )
}

export default OurFeatures